import React, { Component } from 'react';
import { faX, fasShuffle } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon, } from "@fortawesome/react-fontawesome";
import { faShuffle } from '@fortawesome/free-solid-svg-icons/index';

export class SublocationItemInfo extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const removeItemFunction = this.props.removeItem;
        const moveItemFunction = this.props.moveItem;
        const itemInfo = this.props.itemInfo;
        const items = itemInfo.items;
        /*
            items has the following values-
            displayname
            color
            size
        */
        return (
            <>
                <div className="sublocation-item-info">
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Item</th>
                                <th>Color</th>
                                <th>Size</th>
                                <th>Max #</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                items.map((item, index) => {
                                    console.log("ITEM ITEM STUFF", item);
                                    return (
                                        <tr key={item.itemid}>
                                            <td>
                                                <FontAwesomeIcon className="imageIcon" onClick={() => { removeItemFunction(item.itemid, item.stkinfoid)}} size="lg" icon={faX} color="red" />
                                                <br /><br />
                                                <FontAwesomeIcon className="imageIcon" onClick={() => { moveItemFunction(item.stkinfoid, item.itemid, item.displayname) }} size="lg" icon={faShuffle} />
                                            </td>
                                            <td>
                                                <Link
                                                    to={{
                                                        pathname: "/ItemLookup",
                                                        state: { upccode: item.upccode }
                                                    }}><b>{item.displayname}</b>
                                                </Link></td>
                                            <td>{item.color || "N/A"}</td>
                                            <td>{item.size || "N/A"}</td>
                                            <td>{item.maxcapacity || "N/A"  }</td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </>
        );
    }
}